// Services/weatherService.js
export async function getWeather({ latitude, longitude }) {
    const url = new URL("https://api.open-meteo.com/v1/forecast");

    url.searchParams.set("latitude", latitude);
    url.searchParams.set("longitude", longitude);
    url.searchParams.set(
        "current",
        "temperature_2m,relative_humidity_2m,apparent_temperature,weather_code,wind_speed_10m",
    );
    url.searchParams.set(
        "daily",
        "temperature_2m_max,temperature_2m_min,precipitation_probability_max,weather_code,sunrise,sunset",
    );
    url.searchParams.set("hourly", "weather_code,temperature_2m");
    url.searchParams.set("timezone", "auto");
    url.searchParams.set("forecast_days", "16");

    const response = await fetch(url);

    if (!response.ok) {
        throw new Error("Erro ao buscar clima");
    }

    return await response.json();
}
